<h4 *ngFor="let link of links" class="mb-4">
  <u>
    <!-- Href Link -->
    <a
      *ngIf="link.link"
      href="{{ link.link }}"
      target="_blank"
      style="display: flex"
    >
      <div style="max-width: 90%" class="me-1">{{ link.label }}</div>
      <div class="icon ion-md-arrow-round-forward"></div>
    </a>

    <!-- Router Link -->
    <a
      *ngIf="link.routerLink"
      [routerLink]="[link.routerLink]"
      style="display: flex"
    >
      <span style="max-width: 90%" class="me-1">{{ link.label }}</span>
      <span class="icon ion-md-arrow-round-forward"></span>
    </a>
  </u>
</h4>
